import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";
import HcsInfoButton from "./hcs-info-button";

/**
 * @class
 * @classdesc Image selection control using thumbs button with images. Image URLs are being deliverd from within ECS.
 *
 * @param {object} props - Control properties. See {@link HcsControl} for common properties.
 * @param {string} [type=default] - Changes the mode or styling. Possible values are:
 * default: Default style with large thumbs buttons
 * small: Reduced button size, better for attributes with many options.
 */
export default class HcsImageSelect extends HcsCaptionControl {
	constructor(props) {
		super(props);

		this.valueChanged = this.valueChanged.bind(this);

		this.ref = React.createRef();
	}

	valueChanged(attrName, attrValue) {
		let self = this;

		const { data } = this.props;

		if(data.info.value !== attrValue) {
			this.props.checkValueChange(this, {
				confirmed: _ => {
					self.props.onConfig("setCfgValue", attrName, attrValue, {
						sender: "HCS_IMAGESELECT",
						success: _ => {
							super.triggerConfigurator();
						}
					});
				}
			});
		}
	}

	// override from base class
	getCcaoData() {
		const { data } = this.props;

		if(data.info.value !== "") {
			let value = data.values.find(value => {
				return value.ident === data.info.value;
			});

			if(value && value.data.CCAO_DATA) {
				try {
					return JSON.parse(value.data.CCAO_DATA);
				} catch(e) {
					console.error(`Error parsing CCAO_DATA object from ECS for attribute '${data.ident}' with value '${data.info.value}': ${e.message}: ${value.data.CCAO_DATA}`);
				}
			}
		}

		return null;
	}

	childClass() {
		let classNames = ["hcs-image-select"];

		switch(this.props.type) {
			case "small":
				classNames.push("small");
				break;
		}

		return classNames;
	}

	render() {
		const { hcs, data } = this.props;

		return super.render(
			<ul ref={this.ref}>
				{
					data.values.filter((item) => { return item.info.visible; }).map(function(item, index) {
						let cfgSuggest = null;
						let anchorClassNames = ["hcs-icon-link"];

						if(item.flags && item.flags.CFGSuggest) {
							cfgSuggest = {};
							cfgSuggest[item.flags.CFGSuggest] = item.flags.CFGSuggest;
						}

						if(item.info.selected) {
							anchorClassNames.push("hcs-sel");
						}

						return (
							<li key={`hcs-imageselect-${data.ident}-${index}`} {...cfgSuggest}>
								<a title={item.info.trans} onClick={this.valueChanged.bind(this, data.ident, item.ident)} className={anchorClassNames.join(" ")}>
									<img src={hcs.api.getUrl("ConfigImage/icons", item.data.IMAGE)} />
									<span>{item.info.trans}</span>
								</a>
								{item.data.TOOLTIP ?
									<HcsInfoButton contentHtml={item.data.TOOLTIP} /> : null
								}
							</li>
						);
					}, this)
				}
			</ul>
		);
	}
}
